import { render, staticRenderFns } from "./CalendarPicker.vue?vue&type=template&id=63731895&scoped=true&lang=pug&"
import script from "./CalendarPicker.vue?vue&type=script&lang=js&"
export * from "./CalendarPicker.vue?vue&type=script&lang=js&"
import style0 from "./CalendarPicker.vue?vue&type=style&index=0&id=63731895&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63731895",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
installComponents(component, {VDatePicker})
